/**
 * EmptyState — estado vacío con calidez y en español.
 *
 * Decisiones de diseño:
 * - Principio 5 del brief: los estados vacíos tienen calidez explícita — nunca
 *   una superficie en blanco ni un "0". Título + subtítulo obligatorios.
 * - Sin ilustraciones (sistema de diseño utilitario): un ícono lucide apagado
 *   dentro de un círculo suave es suficiente jerarquía.
 * - `action` opcional (ReactNode) para ofrecer el siguiente paso sin acoplar
 *   este componente a ninguna lógica.
 */

const EmptyState = ({ icon: Icon, title, subtitle, action }) => (
  <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
    {Icon && (
      <div
        className="mb-3 flex h-12 w-12 items-center justify-center rounded-lg"
        style={{ background: 'var(--nav-active-bg)' }}
        aria-hidden="true"
      >
        <Icon size={22} style={{ color: 'var(--text-tertiary)' }} />
      </div>
    )}
    <p className="text-sm font-medium" style={{ color: 'var(--text-main)' }}>
      {title}
    </p>
    {subtitle && (
      <p className="mt-1 max-w-sm text-xs leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
        {subtitle}
      </p>
    )}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;

/*
Ejemplo de uso (Manifiesto sin encomiendas):
  import { Inbox } from 'lucide-react';
  <EmptyState
    icon={Inbox}
    title="Todavía no hay encomiendas pendientes."
    subtitle="Cuando un cliente empiece a chatear con el agente, van a aparecer aquí."
  />
*/
